import { useMemo } from 'react';
import { useT } from '../../translation/src';
import { ReferralPayoutCadence, ReferralRole, ReferralSaleState } from '../../types/graphqlTypes';

export const useReferralRoleTranslations = (): Record<ReferralRole, string> => {
  const CUSTOMER = useT('customer', { swc: true });
  const LEAD_GENERATOR = useT('lead generator', { swc: true });
  const RESELLER = useT('reseller', { swc: true });
  const FULL_SERVICE = useT('full-service partner', { swc: true });
  return useMemo(() => ({ CUSTOMER, LEAD_GENERATOR, RESELLER, FULL_SERVICE }), [CUSTOMER, LEAD_GENERATOR, RESELLER, FULL_SERVICE]);
};

export const useReferralPayoutCadenceTranslations = (): Record<ReferralPayoutCadence, string> => {
  const MONTHLY = useT('monthly', { swc: true });
  const YEARLY = useT('yearly', { swc: true });
  return useMemo(() => ({ MONTHLY, YEARLY }), [MONTHLY, YEARLY]);
};

export const useReferralSaleStateTranslations = (): Record<ReferralSaleState, string> => {
  const PENDING = useT('awaiting payment', { swc: true });
  const PAYABLE = useT('payable', { swc: true });
  const PAID_OUT = useT('paid out', { swc: true });
  const VOID = useT('void', { swc: true });
  return useMemo(() => ({ PENDING, PAYABLE, PAID_OUT, VOID }), [PENDING, PAYABLE, PAID_OUT, VOID]);
};
